/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Optional object that is returned if a bookmark was made on a particular item.
 * @export
 * @interface GetCorporationsCorporationIdBookmarksItem
 */
export interface GetCorporationsCorporationIdBookmarksItem {
    /**
     * item_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarksItem
     */
    itemId: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarksItem
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdBookmarksItem interface.
 */
export function instanceOfGetCorporationsCorporationIdBookmarksItem(value: object): value is GetCorporationsCorporationIdBookmarksItem {
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdBookmarksItemFromJSON(json: any): GetCorporationsCorporationIdBookmarksItem {
    return GetCorporationsCorporationIdBookmarksItemFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdBookmarksItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdBookmarksItem {
    if (json == null) {
        return json;
    }
    return {
        
        'itemId': json['item_id'],
        'typeId': json['type_id'],
    };
}

export function GetCorporationsCorporationIdBookmarksItemToJSON(json: any): GetCorporationsCorporationIdBookmarksItem {
    return GetCorporationsCorporationIdBookmarksItemToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdBookmarksItemToJSONTyped(value?: GetCorporationsCorporationIdBookmarksItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'item_id': value['itemId'],
        'type_id': value['typeId'],
    };
}

